// @ts-strict-ignore
import type { ApiError } from '@empathyco/playboard-core-domain'
import type { SetupContext } from 'vue'
import type {
  IToolingFormComposable,
  IToolingFormComposableMethods,
  IToolingListComposableProps,
} from '../../../composables'
import type { IToolingBaseComposableDataItem } from '../../../composables/use-tooling-base'
import type { Equalize } from '../../../modules/equalize'
import { ConflictApiError } from '@empathyco/playboard-core-domain'
import { getCurrentInstance } from 'vue'
import { useApiError } from '../../../composables'

interface IEqualizeViewDataMethodsProps {
  toolingForm: IToolingFormComposable<Equalize>
}

export const methodsFn = <DataItemType extends IToolingBaseComposableDataItem>(
  props: IToolingListComposableProps,
  ctx: SetupContext,
  { toolingForm }: IEqualizeViewDataMethodsProps,
): Partial<IToolingFormComposableMethods<DataItemType>> => {
  const { emit } = ctx

  const {
    proxy: { $epb },
  } = getCurrentInstance()

  const { getErrorMessage } = useApiError()

  async function onAccept(): Promise<void> {
    await toolingForm.onAccept({ errorHandler })
  }

  function errorHandler(error: ApiError): void {
    if (error instanceof ConflictApiError) {
      const messages = $epb.messages.tools.equalize.conflictErrorForm
      const buildMessage = $epb.utils.compileMessage(messages.message as string, {
        id: error.conflictingElements[0].id,
      })
      emit('showCustomError', {
        title: messages.title,
        messages: [buildMessage, messages.continue],
        primaryButtonClick() {
          toolingForm.item.value.criteria.enabled = false
          onAccept()
        },
      })
    } else {
      emit('showError', getErrorMessage(error))
    }
  }

  return {
    onAccept,
  }
}
